import type { AssetKind, ImageAsset, OutputAsset } from '../interfaces'
import type { NordyUser } from '../interfaces/user.interface'
import type { InputItemType } from '../utils/createImage'

import { createInputAssetApi } from '../utils/createImage'
import { queryString } from '../utils/queryString'
import { nordyAxios } from './client'

export const assetApi = {
  createInputAsset: async ({
    file,
    assetKind
  }: {
    file: InputItemType
    assetKind: AssetKind
  }): Promise<ImageAsset> => {
    const inputAsset = await createInputAssetApi({ file, kind: assetKind })
    return inputAsset.asset
  },

  getInputAssets: async ({
    currentPage,
    viewCount,
    assetKind
  }: {
    currentPage: number
    viewCount: number
    assetKind?: AssetKind
  }) => {
    const params = new URLSearchParams()
    params.append('page', currentPage.toString())
    params.append('limit', viewCount.toString())
    params.append('assetKind', assetKind?.toString() ?? '')

    const { data } = await nordyAxios.get(
      `/v1/input-asset/my?${params.toString()}`
    )

    return data
  },

  deleteInputImages: async ({ ids }: { ids: string[] }) => {
    const response = await nordyAxios.patch<{
      acknowledged: boolean
      deletedCount: number
    }>(`/v1/input-asset/delete`, { ids })
    return response.data
  },

  getInputAssetCount: async ({ userId }: { userId?: string }) => {
    const response = await nordyAxios.get<number>(
      `/v1/input-asset/count?${queryString({
        filter: {
          user: userId
        }
      })}`
    )
    return response.data
  },

  // 서버 통제 전용 엔드포인트(asset populate + -prompt + isPreview 정렬 고정). output-asset generic find 락다운 대체.
  getOutputAssetByJobId: async (jobId: string) => {
    const { data } = await nordyAxios.get<
      OutputAsset<NordyUser, string, ImageAsset>[]
    >(`/v1/output-asset/job/${jobId}/results`)
    return data
  },

  // 드래그-인 워크플로우 복원: 소스 워크플로우 비공개면 서버가 prompt를 null로 게이트한다(그래프 유출 방지).
  getOutputAssetPromptByJobId: async (jobId: string) => {
    const { data } = await nordyAxios.get<{ prompt: string | null }>(
      `/v1/output-asset/job/${jobId}/workflow-restore`
    )
    return data.prompt ? data : null
  },

  getOutputAssetUrlsByJobId: async (jobId: string) => {
    // 백엔드 findAssetUrlsByJobId 반환 키는 outputAsset(배열). 기존 outputAssets(복수) 구조분해는 항상 undefined였음.
    const { data } = await nordyAxios.get<{
      outputAsset: OutputAsset<NordyUser, string, ImageAsset>[]
      assetUrls: string[]
    }>(`/v1/output-asset/job/${jobId}/asset-urls`)
    return data.outputAsset
  }
}
